import ReactOtpInput from "react-otp-input"
import { OTPInput } from "./OTPInput"

interface Props {
  otp: string
  setOtp: (otp: string) => void
}

export const OTPInputGroup: React.FC<Props> = ({ otp, setOtp }) => {
  return (
    <div
      onFocusCapture={e => e.preventDefault()}
      className="flex h-14 items-center rounded-full border border-bg-3 bg-bg-2 px-4">
      <ReactOtpInput
        value={otp}
        onChange={setOtp}
        placeholder="••••••"
        numInputs={6}
        skipDefaultStyles={true}
        renderSeparator={<div className="w-2 shrink-0" />}
        shouldAutoFocus={false}
        renderInput={(props, i) => <OTPInput {...props} type="tel" autoFocus={false} className="w-[18%] text-center" />}
      />
    </div>
  )
}
